import { render } from "./Instruction.vue?vue&type=template&id=0aa61524&scoped=true"
import script from "./Instruction.vue?vue&type=script&lang=ts"
export * from "./Instruction.vue?vue&type=script&lang=ts"

import "./Instruction.vue?vue&type=style&index=0&id=0aa61524&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0aa61524"

export default script